import React from "react";
import * as Redux from 'react-redux';
import {Link} from 'react-router-dom';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Modal, Button, Dimmer, Header, Embed } from 'semantic-ui-react';
import $ from 'jquery';
import linkifyHtml from 'linkifyjs/html';

import TopMenu from './TopMenu';
import Messages from './Messages';
import Component from './Component';
import * as accountActions from './../actions/accountActions';
import * as brokerActions from './../actions/brokerActions';
import * as configActions from './../actions/configActions';
import * as landlordActions from './../actions/landlordActions';
import * as userActions from './../actions/userActions';
import * as rentalActions from './../actions/rentalActions';
import * as messageActions from './../actions/messageActions';
import * as configHelper from './../helpers/configHelper';
import * as displayHelper from './../helpers/displayHelper';
import * as addressHelper from './../helpers/addressHelper';
import userImage from './../images/user-image.svg';
import * as utils from "../helpers/utils";

const moment = extendMoment(Moment);

export class Dashboard extends Component {
	constructor(props) {
      super(props);
      
      const activitesFilters = localStorage.getItem("activities_filters");
      
      this.state = {...this.defaultState, posts: null, agencies: [], agents: [], feeds: null, landlords: [], isDisplayQuickSurvey: false,
         rentals: [], buildings: [], deals: [], counts: null, last_date: null, load_feed: false, activitesFilters};

      this.longPostMinLength = 180;

      this.handlePostMessage = this.handlePostMessage.bind(this);
      this.handleHidePost = this.handleHidePost.bind(this);
      this.handleDeleteFeed = this.handleDeleteFeed.bind(this);
      this.handleShowRentals = this.handleShowRentals.bind(this);
      this.handleRestore = this.handleRestore.bind(this);
      this.handleConfirmRestoreLandlord = this.handleConfirmRestoreLandlord.bind(this);
      this.loadMoreFeeds = this.loadMoreFeeds.bind(this);
      this.handleCancel = this.handleCancel.bind(this);
      this.handleDismissGetStarted = this.handleDismissGetStarted.bind(this);
      this.handleFilterFeed = this.handleFilterFeed.bind(this);
      this.resetFeeds = this.resetFeeds.bind(this);
      this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
      this.handleShowSendingListings = this.handleShowSendingListings.bind(this);
      this.handleQuickSurvey = this.handleQuickSurvey.bind(this);
      this.handleQuickSurveyClose = this.handleQuickSurveyClose.bind(this);
	}

	initialize(props, state) {
      const {dispatch, config, match} = props;
      if (config.isLoaded && config.user.is_ygl)
         return;

		var newState = super.initialize(props, state);
		
		this.loadMoreFeeds();

		dispatch(configActions.getCounts()).then(counts => {
			if (counts) {
				utils.storeLocalCache(config, 'ygl-counts', counts);
				!this.__isCancelled && this.setState({counts, lastUpdate: new Date().getTime()});
			}
		});

		var isBrokerConnect = this.props.match.path.indexOf("/brokers/connect") !== -1;
		if (isBrokerConnect) {
			dispatch(brokerActions.startConnectBroker(match.params.encryptId)).then(res => {
				if (res.ok)
					dispatch(messageActions.raiseSuccess(res.message));
				else
					dispatch(messageActions.raiseError(res.message));
			});
		}

		this.setState({...state, ...newState});
	}

	initialized() {
      const {config} = this.props;
         
      if (config.isLoaded && config.user.is_ygl) {
         super.initialized();
         return;
      }

		$('.ui.normal.dropdown.filter').dropdown();

		var feeds = utils.loadLocalCache(config, 'ygl-feeds');
		var counts = utils.loadLocalCache(config, 'ygl-counts');
    	if (feeds)
    		this.processFeeds(this.state, feeds, counts);

		super.initialized();
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (!super.shouldComponentUpdate(nextProps, nextState))
			return false;

		if (this.state.load_feed !== nextState.load_feed && nextState.load_feed)
			this.loadMoreFeeds(nextState);

		return true;
   }
   
   componentDidUpdate() {
      super.componentDidUpdate();
      $(".post-content").each((idx, item) => {
         $(item).html(linkifyHtml($(item).html()));
      });
   }

   handleShowSendingListings(e) {
      const {config} = this.props;
      const ids = config.counts.sending_rentals.join(",");
		window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals?id=" + ids;
   }
   
   handleTextareaFocus(e) {
      e.target.setAttribute('rows', 3);
   }

   handleTextareaBlur(e) {
      // fix for issue #327
      const target = e.target;
      setTimeout(() => target.setAttribute('rows', 1), 300);
   }

   handleFilterFeed(e) {
      const filter = this.refs.filterSelector.value.trim();
      localStorage.setItem('activities_filters', filter);
      this.resetFeeds();
   }

   handleRestore(rentalId) {
		const {dispatch} = this.props;

		dispatch(rentalActions.startRestoreRental(rentalId)).then(errors => {
			if (errors === null) {
				this.refs.rentalsModal.trySetState({open: false});
				dispatch(messageActions.raiseSuccess("Listing successfully restored."));
			}
		});
	}

    handleRestoreLandlord(e, landlordId) {
        e.preventDefault();
        this.refs.restoreLandlordModal.landlordId = landlordId;
        this.refs.restoreLandlordModal.trySetState({open: true});
    }

    handleConfirmDelete(feedId) {
        this.toDeleteId = feedId;
        this.refs.deleteFeedConfirmationModal.trySetState({open: true});
    }

	handleConfirmRestoreLandlord(e) {
      e.preventDefault();
      const {dispatch} = this.props;
      
      this.refs.restoreLandlordModal.trySetState({open: false});
      let landlordId = this.refs.restoreLandlordModal.landlordId;

		dispatch(landlordActions.startRestoreLandlord(landlordId)).then(errors => {
			if (errors === null) {
				 dispatch(messageActions.raiseSuccess("Landlord successfully restored."));
			} 
		});
   }
   
   handleQuickSurvey(e) {
      e.preventDefault();
      const {dispatch} = this.props;
      
      if (this.refs.quick_survey.value.length === 0)
         return;

      dispatch(userActions.submitSurvey("Zillow & Craigslist charge per ad, would you be willing to pay by lead? If so, how much would you be willing to pay?", 
         this.refs.quick_survey.value)).then(isOk => {
         if (isOk) {
            dispatch(messageActions.raiseSuccess("Thank you for answering our question.  We appreicate your help."));
            this.setState({isDisplayQuickSurvey: false});
         }
		});
   }

   handleQuickSurveyClose(e) {
      e.preventDefault();
      const {dispatch} = this.props;
      
      dispatch(userActions.closeSurvey()).then(isOk => {
         this.setState({isDisplayQuickSurvey: false});
		});
   }

	handleDismissGetStarted(e) {
		e.preventDefault();
		const {dispatch} = this.props;

		dispatch(configActions.startTurnOffGettingStarted()).then(res => {
		});
	}

	handlePostMessage() {
		const {dispatch} = this.props;
		
		var data = {message: this.refs.message.value};
		if (this.refs.post_type_internal_agents && this.refs.post_type_internal_agents.checked)
			data.post_type = this.refs.post_type_internal_agents.value;
		else if (this.refs.post_type_network_brokers && this.refs.post_type_network_brokers.checked)
			data.post_type = this.refs.post_type_network_brokers.value;

		dispatch(accountActions.savePost(data)).then(res => {
			if (res) {
				if (res.id) {
					this.refs.message.value = "";
					dispatch(accountActions.getPosts()).then(posts => !this.__isCancelled && this.setState({...posts}));
				} else {
					for(var i in res) {
						dispatch(messageActions.raiseError(res[i]));
					}
				}
			}
			window.scrollTo(0,0);
		});
	}

	handleHidePost(id) {
		const {dispatch} = this.props;

		dispatch(accountActions.hidePost(id)).then(isSuccess => {
			if (isSuccess) {
				var {posts} = this.state;
				posts = posts.filter(post => post.id !== id);
				!this.__isCancelled && this.setState({posts});
			}
		});
	}

	handlePostMore(e, content) {
      e.target.previousElementSibling.innerText = content;
      $(e.target.previousElementSibling).html(linkifyHtml($(e.target.previousElementSibling).html()));
      e.target.hidden = true;
	}

	handleDeleteFeed(e) {
        e.preventDefault();
        const id = this.toDeleteId;
        if (!id)
            return;
		const {dispatch} = this.props;

        this.refs.deleteFeedConfirmationModal.trySetState({open: false});
		dispatch(accountActions.deleteFeed(id)).then(isSuccess => {
			if (isSuccess) {
				var {feeds} = this.state;
				feeds = feeds.filter(feed => feed.id !== id);
				!this.__isCancelled && this.setState({feeds});
			}
		});
	}

	handleCancel(e) {
		e.preventDefault();
		this.refs.rentalsModal.trySetState({open: false});
        this.refs.restoreLandlordModal.trySetState({open: false});
        this.refs.deleteFeedConfirmationModal.trySetState({open: false});
    }

	handleShowRentals(title, rentalIds) {
		var {config} = this.props;
		var {rentals} = this.state;

		var renderAvailableDate = (listDate) => {
			if (listDate !== null) {
				var date = moment(listDate, ['MM/DD/YYYY', 'YYYY-MM-DD']);
				var now = new moment();
				if (now.unix() >= date.unix()) {
					const dr = moment.range(date, now);
					return "NOW (" + dr.diff('days') + ")";
				} else {
					return date.format("MM/DD/YYYY");
				}
			} else {
				return "";
			}
		};

		var isDeleted = title === "Deleted Rentals";

		var body = <div className={`ui celled grid ygl-table rentals-dashboard no-border-top`}>
        	{ rentals.map(rental => {
				if (rentalIds.includes(rental.id)) {
					return (
						<div key={rental.id} className="row">
							<div className="column neighborhood">
								{ rental.neighborhood && rental.neighborhood.length > 0 ? rental.neighborhood : rental.city }
							</div>

							<div className="column home-link">
								{
									isDeleted 
										? <div>{rental.street_number} {rental.street_name}</div>
										: <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals/" + rental.id} onClick={e => {
											this.refs.rentalsModal.trySetState({open: false});
                                 return true;
										}} target="_blank">{rental.street_number} {rental.street_name}</a>
								}
							</div>
							<div className="column unit"><i className="fa fa-hashtag"></i>&nbsp;{rental.unit}</div>
							<div className="column price"><i className="fa fa-usd"></i>&nbsp;{configHelper.numberWithCommas(rental.price)}</div>
							<div className="column beds">
								<i className="fa fa-bed"></i>&nbsp;<span>{displayHelper.bedsDisplay(config, rental.beds, rental.room)}</span>
							</div>
							<div className="column baths">
								<i className="fa fa-bath"></i>&nbsp;<span>{rental.baths}</span>
							</div>
							<div className="column fee">
								{configHelper.feeDisplay(config, rental.fee)}
							</div>
							<div className="column available-date">
								<i className="fa fa-calendar"></i>&nbsp;<span>{renderAvailableDate(rental.list_date)}</span>
							</div>
							{
								isDeleted && config.isLoaded && configHelper.canUpdate(config) 
									? <div className="column icons"><a onClick={e => {
										e.preventDefault();
										this.handleRestore(rental.id);
									}}>undo</a></div>
									: ""
							}
						</div>
					);
				} else 
					return "";
			}) }	
			</div>;

		this.setState({title, body});
		this.refs.rentalsModal.trySetState({open: true});
	}

	resetFeeds() {
		this.setState({last_date: null, agencies: [], landlords: [], feeds: [], rentals: [], buildings: [], deals: [], load_feed: true});
	}

	loadMoreFeeds(state = null) {
		const {dispatch, config} = this.props;
		const filter = this.refs.filterSelector.value.trim();
		if (!state)
			state = this.state;
		
		dispatch(accountActions.getFeeds(filter, state.last_date)).then(newFeeds => {
			if (!newFeeds)
				return;
			
			utils.storeLocalCache(config, 'ygl-feeds', {...newFeeds, last_date: null});
			this.processFeeds(this.state, newFeeds);
		});
	}

	processFeeds(state, data, counts = null) {
		var {agencies, landlords, agents, feeds, rentals, buildings, deals, posts, last_date, quick_survey} = data;
		if (!counts)
			counts = state.counts;

		if (agencies && agencies.length > 0) {
			if (this.state.last_date && state.agencies && state.agencies.length > 0) 
				agencies = state.agencies.concat(agencies);
		} else
			agencies = state.agencies;

		if (agents && agents.length > 0) {
			if (this.state.last_date && state.agents && state.agents.length > 0)
				agents = state.agents.concat(agents);
		} else
			agents = state.agents;

		if (posts && posts.length === 0) {
			posts = state.posts;
		}

		if (landlords && landlords.length > 0) {
			if (this.state.last_date && state.landlords && state.landlords.length > 0)
				landlords = state.landlords.concat(landlords);
		} else
			landlords = state.landlords;

		if (feeds && feeds.length > 0) {
			if (this.state.last_date && state.feeds && state.feeds.length > 0) {
				feeds = state.feeds.concat(feeds);
			}
		} else
			feeds = state.feeds;

		if (rentals && rentals.length > 0) {
			if (this.state.last_date && state.rentals && state.rentals.length > 0)
				rentals = state.rentals.concat(rentals);
		} else
			rentals = state.rentals;

		if (buildings && buildings.length > 0) {
			if (this.state.last_date && state.buildings && state.buildings.length > 0)
				buildings = state.buildings.concat(buildings);
		} else
			buildings = state.buildings;

		if (deals && deals.length > 0) {
			if (this.state.last_date && state.deals && state.deals.length > 0)
				deals = state.deals.concat(deals);
		} else
         deals = state.deals;
         
      var isDisplayQuickSurvey = quick_survey;

		this.setState({agencies, agents, landlords, rentals, feeds, buildings, deals, posts, counts, last_date, isDisplayQuickSurvey, load_feed: false});
	}

	render() {
		const {config, loading} = this.props;
        var {posts, agents, agencies, feeds, landlords, rentals, buildings, deals, counts, last_date, 
            activitesFilters, isDisplayQuickSurvey} = this.state;
		var tutorialWidth = window.innerWidth < 768 ? Math.ceil(window.innerWidth * .8) : Math.ceil(window.innerWidth * .6);

      document.title = "Dashboard";
      
      // For YGL user, no need to display anything.
      if (config.isLoaded && config.user.is_ygl) {
         console.log("Redirecting to " + process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN);
         window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN;
         return <div></div>
      }

		var renderFeedBody = (feed) => {
			switch(feed.type) {
				case "AG":
               var matchLandlords = landlords.filter(landlord => landlord.id === feed.landlord_id);
               if (matchLandlords.length > 0) {
                  return (
                        <div>You are now connected to {
                           configHelper.canShowLandlordInfo(config)
                              ? <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "landlords/" + matchLandlords[0].id}>{matchLandlords[0].name}</a>
                              : matchLandlords[0].name
                        }.</div>
                  );
               }
               break;
				case "RS":
            case "RI":
					return (
						<div>
							{
								feed.onmarket_ids.length > 0 ? <a className="rental-status green" href='/' onClick={e => {
									e.preventDefault();
									this.handleShowRentals('On Market Rentals', feed.onmarket_ids);
								}}><span>{configHelper.configName(config.rental_statuses, "ONMARKET")}:</span>&nbsp;{feed.onmarket_ids.length}</a> : ""
							}
							{
								feed.pending_ids.length > 0 ? <a className="rental-status orange" href='/' onClick={e => {
									e.preventDefault();
									this.handleShowRentals('Pending Rentals', feed.pending_ids);
								}}><span>{configHelper.configName(config.rental_statuses, "APP")}:</span>&nbsp;{feed.pending_ids.length}</a> : ""
							}
							{
								feed.offmarket_ids.length > 0 ? <a className="rental-status red" href='/' onClick={e => {
									e.preventDefault();
									this.handleShowRentals('Off Market Rentals', feed.offmarket_ids);
								}}><span>{configHelper.configName(config.rental_statuses, "OFFMARKET")}:</span>&nbsp;{feed.offmarket_ids.length}</a>: ""
							}
							{
								feed.deleted_ids.length > 0 ? <a className="rental-status black" href='/' onClick={e => {
									e.preventDefault();
									this.handleShowRentals('Deleted Rentals', feed.deleted_ids);
								}}><span>Deleted:</span>&nbsp;{feed.deleted_ids.length}</a>: ""
							}
						</div>
					);
				case "UP":
               var matchRentals = rentals.filter(rental => rental.id === feed.rental_id);
               if (matchRentals.length > 0) {
                  return <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals/" + matchRentals[0].id + "/photos"}>{feed.photo_ids.length + feed.landlord_photo_ids.length} uploaded - {addressHelper.formatRentalAddress(matchRentals[0])}</a>;
               }
               break;
				case "BP":
               var matchBuildings = buildings.filter(building => building.id === feed.building_id);
               if (matchBuildings.length > 0) {
                  var buildingPhotoMsg = (feed.photo_ids.length + feed.landlord_photo_ids.length) + " uploaded - " + addressHelper.formatRentalAddress(matchBuildings[0]);
                  if (feed.unit_id)
                     return <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals/" + feed.unit_id + "/photos"}>{buildingPhotoMsg}</a>;
                  else
                     return <span>{buildingPhotoMsg}</span>;
               }
               break;
            case "UV":
               var matchRentals = rentals.filter(rental => rental.id === feed.rental_id);
               if (matchRentals.length > 0) {
                  var tourMsg = (feed.video_ids.length + feed.landlord_video_ids.length) + " uploaded - " + addressHelper.formatRentalAddress(matchRentals[0]);
                  return <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals/" + matchRentals[0].id + "/photos"}>{tourMsg}</a>;
               }
               break;
            case "BV":
               var matchBuildings = buildings.filter(building => building.id === feed.building_id);
               if (matchBuildings.length > 0) {
                  var buildingPhotoMsg = (feed.video_ids.length + feed.landlord_video_ids.length) + " uploaded - " + addressHelper.formatRentalAddress(matchBuildings[0]);
                  if (feed.unit_id)
                     return <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals/" + feed.unit_id + "/photos"}>{buildingPhotoMsg}</a>;
                  else
                     return <span>{buildingPhotoMsg}</span>;
               }
               break;
            case "LD":
            case "LI":
               matchLandlords = landlords.filter(landlord => landlord.id === feed.landlord_id);
               if (matchLandlords.length > 0) {
                  return <span>
                  Landlord Deleted&nbsp;
                        {
                           config.isLoaded && configHelper.canUpdate(config) &&
                           <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "landlords/" + feed.landlord_id}>view</a>
                        }
                  </span>;
               }
               break;
				case "AJ":
               return <span>New broker connected.</span>;
            case "AR":
               return <span>Broker disconnected.</span>;
            case "ND":
               var matchDeals = deals.filter(deal => deal.id === feed.deal_id);
               if (matchDeals.length > 0) {
                  var deal = matchDeals[0];
                  return <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "deals/" + deal.id} target="_blank">{addressHelper.formatRentalAddress(deal, true, false)}</a>;
               }
               break;
				default:
					break;
			}
					
			return "";
		};

		var renderFeedIcon = (feed) => {
			switch(feed.type) {
				case "RS":
            case "RI":
               return <i className="ygl-icon house-icon"></i>;
				case "AG":
				case "AJ":
            case "AR":
               return <i className="ygl-icon linked-icon"></i>;
				case "LD":
            case "LI":
					return <i className="ygl-icon house-icon"></i>;
				case "UP":
				case "BP":
               return <i className="fa fa-camera"></i>;
            case "UV":
            case "BV":
               return <i className="fa fa-street-view"></i>;
				case "ND":
               return <i className="fa fa-usd"></i>;
				default:
					break;
			}

			return "";
		};

		var renderFeedTitle = (feed) => {
			var title = "";
			var matchLandlords = null
			switch(feed.type) {
				case "RS":
            case "RI":
					matchLandlords = landlords.filter(landlord => landlord.id === feed.landlord_id);
					if (matchLandlords.length > 0) {
                  title = <span>
                     {matchLandlords[0].name} Listing Updates <span className="source">{config.rental_sources.length > 1 ? "(" + configHelper.sourceDisplay(config, matchLandlords[0].source) + ")" : ""}</span>
                  </span>;
               } else {
                  title = <span>Unknown Landlord</span>;
               }
					break;
				case "AG":
					matchLandlords = landlords.filter(landlord => landlord.id === feed.landlord_id);
					if (matchLandlords.length > 0) {
                  title = <span>New Landlord Connected</span>;
					}
					break;
				case "AJ":
            case "AR":
					var matchAgencies = agencies.filter(agency => agency.id === feed.to_agency_id);
               if (matchAgencies.length > 0)
                  title = <span>{matchAgencies[0].name}</span>;
					break;
				case "UP":
					title = <span>New Unit Photo{feed.photo_ids.length + feed.landlord_photo_ids.length > 1 ? "s" : ""}</span>;
					break;
				case "BP":
               title = <span>New Building Photo{feed.photo_ids.length + feed.landlord_photo_ids.length > 1 ? "s" : ""}</span>;
               break;
            case "UV":
               title = <span>New Unit Virtual Tour{feed.video_ids.length + feed.landlord_video_ids.length > 1 ? "s" : ""}</span>;
               break;
            case "BV":
               title = <span>New Building Virtual Tour{feed.video_ids.length + feed.landlord_video_ids.length > 1 ? "s" : ""}</span>;
               break;
				case "LD":
            case "LI":
               matchLandlords = landlords.filter(landlord => landlord.id === feed.landlord_id);
               if (matchLandlords.length > 0) {
                  title = <span>{matchLandlords[0].name}{config.rental_sources.length > 1 ? " [" + configHelper.sourceDisplay(config, matchLandlords[0].source) + "]" : ""}</span>;
               }
               break;
				case "ND":
					var matchDeals = deals.filter(deal => deal.id === feed.deal_id);
					if (matchDeals.length > 0) {
						var deal = matchDeals[0];
						var matchAgents = agents.filter(agent => agent.id === deal.agent_id);
						if (matchAgents.length > 0)
							title = <span>{displayHelper.nameDisplay(matchAgents[0])} added a new deal</span>;
					}
						
					break;
				default:
					break;
			}

			return title;
		};

		const isValid = (feed) => {
			if (feed.type === "RS") {
				return feed.onmarket_ids.length > 0 || feed.pending_ids.length > 0 || feed.offmarket_ids.length > 0 
					|| feed.deleted_ids.length > 0;			
			}

			return true;
		};

      var currentUserImageElement = <div className="default-user-image"><img src={userImage} alt=""/></div>;
      if(config.user.avatar && config.user.avatar.length > 0){
         currentUserImageElement = <div className="user-image" style={{backgroundImage: `url(${config.user.avatar})`}}/>
      }

      var sendingListingsHasSomething = config.isLoaded && (config.counts.sending_rentals.length > 0 || config.counts.sending_brokers > 0);
      var receivingListingsHasSomething = counts && (counts.receiving_rentals > 0 || counts.receiving_landlords > 0);
      var showSendingListings = config.isLoaded && config.account.can_access_ygl_network && sendingListingsHasSomething 
			&& !(!config.user.role_admin && !config.user.role_manager && !config.user.role_share_listing);
		var showReceivingListings = counts && config.isLoaded && config.account.can_access_ygl_network && receivingListingsHasSomething && !config.account.syndicate.is_share_all;		
      var showLandlordReminders = config.isLoaded && config.user.role_landlord_full && counts && counts.landlord_reminders > 0;
      var newLeadsCounterAvailable = (counts && counts.leads_new > 0);
		var canSeePPosts = config.isLoaded && (config.account.syndicate.is_share_all 
			|| config.counts.sending_brokers > 0 || config.agents.length > 1 || configHelper.hasRentalSource(config, 'S'));
		var canMakePost = true;
		var postsTitle = "Posts";
		var postPlaceholderText = "Share an update...";
		if (config.isLoaded && config.account.syndicate.is_share_all) {
			postsTitle = "Broker Announcements";
			postPlaceholderText = "Make an announcement...";
		}
		else if (config.isLoaded && config.agents.length <= 1) {
			if (config.counts.sending_brokers === 0) {
				canMakePost = false;
				postsTitle = "Landlord Announcements";
			} else {
				canMakePost = true;
				postsTitle = "Announcements";
				postPlaceholderText = "Make an announcement...";
			}
      }
      
      const showSecondColumn = (
			config.isLoaded && (
				showSendingListings || showReceivingListings || canSeePPosts
			)
		);

		return (
			<div>
				<TopMenu />
				<Messages />
				<div className="ui basic segment page-content dashboard-page">
					{
						config.isLoaded && config.account.expires_in_days && config.account.expires_in_days <= 3
							? (configHelper.canManage(config) 
								? <div className={"ui error message"}>There is an outstanding balance due in {config.account.expires_in_days} day{config.account.expires_in_days > 1 ? "s" : ""}.  Please <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "billing/payment"}>make a payment</a> to avoid service interruption.  Thank you.</div>
								: <div className={"ui error message"}>Account will expire in in {config.account.expires_in_days} day{config.account.expires_in_days > 1 ? "s" : ""}.  Please remind your admin to make a payment to avoid service interruption.  Thank you.</div>)
							: ""
					}
               { isDisplayQuickSurvey
                  ?    <div className="ui info message">
                     <i className="close icon" onClick={this.handleQuickSurveyClose}></i>
                     <h4>Quick Survey</h4>
                     <p>Since promenent sites like Zillow and Craigslist started charging for postings recently, we are looking into other possible means to help you advertise your listings.  We are running a series of quick surveys to learn more about your needs.  We appreicate it if you can help us answer them.  Thank you.</p>
                     <h5>Zillow & Craigslist charge per ad, would you be willing to pay by lead? If so, how much would you be willing to pay?</h5>
                     <form className="ui form">
                        <div className="two fields">
                           <div className="four wide field">
                              <select className="ui fluid dropdown" ref="quick_survey">
                                 <option value="">Select...</option>
                                 <option value="0">No, I am not willing to pay per lead.</option>
                                 <option value="3">$1-3 per lead</option>
                                 <option value="6">$4-6 per lead</option>
                                 <option value="10">$6-10 per lead</option>
                                 <option value="15">$10-15 per lead</option>
                                 <option value="20">$15-20 per lead</option>
                                 <option value="20+">$20+ per lead</option>
                              </select>
                           </div>
                           <div className="four wide field">
                              <div className="ui button" onClick={this.handleQuickSurvey}>Submit</div>
                           </div>
                        </div>
                     </form>
                  </div>
                  : ""
               }
               
					<div className="ui stackable grid">
						<div className={`${showSecondColumn ? 'nine' : 'sixteen'} wide column main-column`}>
							{
								counts && (counts.leads_new > 0 || showLandlordReminders) ?
									<div className="ui segment no-content-padding no-padding-top no-padding-bottom">
										<div className="segment-content">
											<div className="ui grid top-counters">
												<table className={newLeadsCounterAvailable && showLandlordReminders ? 'two-columns' : null}>
                                       <tbody>
                                          <tr>
                                             <td>
                                                { newLeadsCounterAvailable &&
                                                   <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "leads?status[0]=NEW"}><label className="ui red circular label">{counts.leads_new.toLocaleString('en-US')}</label>New Leads</a>
                                                }
                                             </td>
                                             <td>
                                                { showLandlordReminders &&
                                                   <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "landlords?reminders[0]=Y&sort_by=reminders&sort_dir=desc"}><label className="ui red circular label">{counts.landlord_reminders}</label>Landlords with Reminder</a>
                                                }
                                             </td>
                                          </tr>
                                       </tbody>
												</table>
											</div>
										</div>
									</div>
									: ""
							}
							<div className="ui segment">
								<div className="segment-header has-dropdown">
                           Activities
                           <select ref="filterSelector" defaultValue={activitesFilters} className="ui normal dropdown filter" onChange={this.handleFilterFeed}>
										<option value=" ">All</option>
			        					<option value="RS,LD,RI,LI">Rental Updates</option>
                              {
                                 config.isLoaded && config.rental_sources.length > 1
                                    ? <option value="RI,LI">Rental Updates (Internal Listings Only)</option>
                                    : ""
                              }
			        					<option value="UP,BP,UV,BV">Photo/Video Uploads</option>
			        					{
			        						config.isLoaded && config.account.is_show_deals
			        							? <option value="ND">Deal Updates</option>
			        							: ""
			        					}
			        					{
			        						(config.isLoaded && config.counts.sending_brokers > 0) || (counts && counts.receiving_landlords > 0)
			        						? <option value="AJ,AG">Network Connections</option>
			        						: ""
			        					}
									</select>
								</div>
                           <div className="segment-content">
                              <div className="ui feed">
                                 {
                                    feeds && feeds.length > 0 &&
                                       feeds.filter(feed => {
                                          return isValid(feed);
                                       }).map(feed => {
                                          var title = renderFeedTitle(feed);

                                          if (title !== null) {
                                             return (
                                                <div key={feed.id} className="event">
                                                      <div className={`content${config.isLoaded && configHelper.canManage(config) ? ' has-actions' : ''}`}>
                                                         {renderFeedIcon(feed)}
                                                         <div className="summary">
                                                            {title}
                                                         </div>
                                                         <div className="extra text">
                                                            {renderFeedBody(feed)}
                                                         </div>
                                                         <div className="date">
                                                            {configHelper.ageDisplay(feed.date)}
                                                         </div>
                                                         { config.isLoaded && configHelper.canManage(config) && feed.type !== 'LD'
                                                            ? <i className="fa fa-trash" onClick={(e) => this.handleConfirmDelete(feed.id)} />
                                                            : ""
                                                         }
                                                      </div>
                                                </div>
                                             );
                                          } else
                                             return ""
                                       })
                                 }
                                 {(!feeds || feeds.length === 0) && <div className="blank-card no-results">No Activities</div>}
                              </div>
                              {
                                 feeds && feeds.length > 0 && last_date !== null ?
                                    <a title="Load more" className="ui grey basic button more-button" onClick={e => this.setState({load_feed: true})}><i className="fa fa-angle-down"></i></a>
                                    : ""
                              }
                           </div>
							</div>
						</div>
						{ showSecondColumn && <div className="seven wide column secondary-column">
                     {
                        showSendingListings ?
                           <div className="ui segment empty">
                                 Sending <Link to="" onClick={this.handleShowSendingListings}><b>{config.counts.sending_rentals.length.toLocaleString(navigator.language)}</b> On Market Listing{config.counts.sending_rentals.length !== 1 ? 's' : ''}</Link> to <b>{config.counts.sending_brokers.toLocaleString(navigator.language)}</b> Network Broker{config.counts.sending_brokers !== 1 ? 's' : ''}
                                 <div>
                                    <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "brokers"}>Manage Brokers</a> &nbsp;<strong>·</strong>&nbsp; <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "network/sheet?download=Y"} target="_blank" rel="noopener noreferrer">Download Listing Sheet</a>
                                 </div>
                           </div>
                           : ""
                     }
							{
                        showReceivingListings ?
									<div className="ui segment empty">
										Receiving <b>{counts.receiving_rentals.toLocaleString('en-US')}</b> On Market Listing{counts.receiving_rentals !== 1 ? 's' : ''} from <b>{counts.receiving_landlords.toLocaleString('en-US')}</b> Landlords
                              { config.isLoaded && (config.user.role_admin || config.user.role_manager) &&
                                 <div>
                                    <a href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "landlords/directory"}>YGL Network Directory</a>
                                 </div>
                              }
									</div>
									: ""
							}
							{
								canSeePPosts ?
									<div className="ui segment">
										<div className="segment-header">
											{postsTitle}
										</div>
										<div className="segment-plain-content posts">
											{
												canMakePost ?
													<div className="item">
														<div className="ui form">
															{ currentUserImageElement }
															<div className="field">
																<textarea onFocus={this.handleTextareaFocus} onBlur={this.handleTextareaBlur}
																	rows="1" ref="message" placeholder={postPlaceholderText} />
                                                            </div>
                                                            {
                                                            	!config.account.syndicate.is_share_all && config.counts.sending_brokers > 0 && configHelper.canShare(config) && config.agents.length > 1
                                                            		? <div className="new-post-options">
                                                            			<label><input type="radio" ref="post_type_internal_agents" name="post_type" value="internal" defaultChecked={true} />&nbsp;For&nbsp;Internal&nbsp;Agents</label>
                                                            			<label><input type="radio" ref="post_type_network_brokers" name="post_type" value="brokers" />&nbsp;For&nbsp;Network&nbsp;Brokers</label>
                                                            		</div>
                                                            		: ""
                                                            }
															<Button primary floated="right" loading={loading.length > 0} disabled={loading.length > 0} onClick={this.handlePostMessage}>Post</Button>
															<div style={{clear: 'both'}}></div>
														</div>
													</div>
													: ""
											}

											{
                                    config.isLoaded && posts && posts.length > 0 
                                       && posts.map(post => {
                                       if (post.published_by_name === config.account.share_landlord.name) {
                                          if (post.is_email_brokers && !configHelper.canShare(config))
                                             return <div key={post.id}></div>;
                                       }
                                          var matchAgents = agents.filter(agent => agent.id === post.published_by);
                                          var agent = matchAgents.length > 0 ? matchAgents[0] : null;
                                          var canDelete = false;

                                          if (configHelper.canManage(config))
                                             canDelete = true;

                                          if (post.is_email_brokers && configHelper.canShare(config))
                                             canDelete = true;

                                          if (post.published_by === config.user.id)
                                             canDelete = true;

                                          var userImageElement = <div className="default-user-image"><img src={userImage} alt=""/></div>;
                                          if(agent && agent.avatar && agent.avatar.length > 0){
                                             userImageElement = <div className="user-image" style={{backgroundImage: `url(${agent.avatar})`}}/>
                                          }

                                          var longPost = (post.content.length > this.longPostMinLength);

                                          return (
                                             <div key={post.id} className="item">
                                                <div className="top-line">
                                                   { userImageElement }
                                                   <strong>
                                                   {post.published_by_name}
                                                </strong>
                                                   <div className="date">
                                                   {configHelper.ageDisplay(post.created_at)}
                                                   </div>
                                                </div>

                                                <div className={`content${canDelete ? ' has-delete' : ''}`}>
                                                   <span className="post-content">{longPost ? post.content.substr(0, this.longPostMinLength) : post.content}</span>
                                                   {longPost && <a style={{cursor: 'pointer'}} onClick={(e) => this.handlePostMore(e, post.content)}> ... [more]</a>}
                                                   { canDelete
                                                      ? <i className="fa fa-trash" onClick={(e) => this.handleHidePost(post.id)} />
                                                      : ""
                                                   }
                                                </div>
                                             </div>
                                          );
                                       })
											}
                                 {(!posts || posts.length === 0) && <div className="blank-card no-results">No Posts</div>}
										</div>
									</div>

								: ""
							}
						</div>}
					</div>
				</div>
				<Modal ref="rentalsModal" closeIcon>
					<Modal.Header>{this.state.title}</Modal.Header>
					<Modal.Content>{this.state.body}</Modal.Content>
					<Modal.Actions>
						<Button primary onClick={this.handleCancel}>OK</Button>
					</Modal.Actions>
				</Modal>
				<Modal ref="restoreLandlordModal" size="mini" closeIcon>
					<Modal.Header>Undo</Modal.Header>
					<Modal.Content>Restore landlord?</Modal.Content>
					<Modal.Actions>
						<Button secondary onClick={this.handleCancel}>Cancel</Button>
                        <Button primary onClick={this.handleConfirmRestoreLandlord}>OK</Button>
					</Modal.Actions>
				</Modal>
                <Modal ref="deleteFeedConfirmationModal" size="mini" closeIcon>
					<div className="header">
				  		Delete Selected Feed?
				  	</div>
				  	<div className="content">
                        {
                            config.agents.length > 1 
                                ? "This feed would be deleted for the whole office, continue?"
                                : "Are you sure to delete this feed?"
                        }
				  	</div>
				  	<Modal.Actions>
				    	<Button secondary onClick={this.handleCancel}>Cancel</Button>
				    	<Button primary onClick={this.handleDeleteFeed}>OK</Button>
				  	</Modal.Actions>
				</Modal>
				<Dimmer active={config.isLoaded && !!config.account.is_premium && config.user.setting_general_tutorial !== "INA"} page>
					<Header as='h2' inverted>
						Welcome to <span style={{whiteSpace: "nowrap"}}>You Got Listings!</span>
					</Header>
					<div style={{width:tutorialWidth + "px"}}>
						<Embed id='CSyO0aBwEb4' source='youtube' autoplay={true} active={true} />
					</div>
					<br/>
					<br/>
					<Button primary onClick={this.handleDismissGetStarted}>Close Tutorial</Button>
				</Dimmer>
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard.js